/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Lock rotation within plane</h4>

<p>When active, the location direction is picked up from the initial mouse movement and locked within the horizontal or vertical planes.</p>`;

export default function ToggleLockedRotateTooltip() {
    return h('div', { innerHTML: body });
}
